// helpers
import {
  checkErrorStatusForAllDays,
  checkErrorValidationForAllDays,
  isPricingStepReadOnly,
  offersStep
} from "../../../pages/Offers/offersHelpers";

import { isEqualOrGreater, checkForEmptyField, checkForValidEmail } from "@gl-shared/shared/helpers";

export const errorFieldActionTypes = {
  TOGGLE_ERROR_FIELD: "TOGGLE_ERROR_FIELD",
  RESET_ERROR_FIELD: "RESET_ERROR_FIELD"
};

export const initialState = {
  errorExists: false,
  errorField: null
};

const errorFieldReducer = (state = initialState, action) => {
  switch (action.type) {
    case errorFieldActionTypes.TOGGLE_ERROR_FIELD:
      return {
        ...state,
        errorExists: action.errorExists,
        errorField: action.errorField
      };
    case errorFieldActionTypes.RESET_ERROR_FIELD:
      return {
        ...state,
        errorExists: false,
        errorField: null
      };
    default:
      return state;
  }
};

export default errorFieldReducer;

export const errorFieldActionCreators = {
  // handling error fields before validation of switching steps for Hotel Offer Management
  errorFieldCheckInStepAction: (step, data) => (dispatch, getState) => {
    let errorCheck = true;
    switch (step) {
      case offersStep.offerDetails:
        let offerDetailsErrorField = {
          offer_name: false,
          event_categories: false,
          short_description: false,
          long_description: false
        };

        if (checkForEmptyField(data.name)) {
          offerDetailsErrorField["offer_name"] = true;
          errorCheck = false;
        }
        if (checkForEmptyField(data.short_description)) {
          offerDetailsErrorField.short_description = true;
          errorCheck = false;
        }
        if (checkForEmptyField(data.long_description)) {
          offerDetailsErrorField.long_description = true;
          errorCheck = false;
        }
        if (data.event_categories.length === 0) {
          offerDetailsErrorField.event_categories = true;
          errorCheck = false;
        }
        dispatch({
          type: errorFieldActionTypes.TOGGLE_ERROR_FIELD,
          errorExists: !errorCheck,
          errorField: offerDetailsErrorField
        });
        return errorCheck;

      case offersStep.pricing:
        // Skip pricing validation while the step is read-only so create/edit flows are not blocked.
        if (isPricingStepReadOnly) {
          return errorCheck;
        }

        let pricingErrorField = {
          vat: false,
          base_price: false,
          allow_children: false,
          child_price: false,
          infant_price: false,
          additional_unit_price: false,
          price_type: false
        };
        const offerPrices = data?.offer_prices ?? [];
        const basePriceItem = offerPrices[0];
        if (checkForEmptyField(data.vat)) {
          pricingErrorField.vat = true;
          errorCheck = false;
        }
        if (checkForEmptyField(basePriceItem?.price)) {
          pricingErrorField.base_price = true;
          errorCheck = false;
        }
        if (checkForEmptyField(basePriceItem?.price_additional)) {
          pricingErrorField.additional_unit_price = true;
          errorCheck = false;
        }
        if (offerPrices.length >= 2 && checkForEmptyField(offerPrices[1]?.price)) {
          pricingErrorField.child_price = true;
          errorCheck = false;
        }
        if (offerPrices.length >= 3 && checkForEmptyField(offerPrices[2]?.price)) {
          pricingErrorField.infant_price = true;
          errorCheck = false;
        }
        if (checkForEmptyField(data.price_type?.value)) {
          pricingErrorField.price_type = true;
          errorCheck = false;
        }

        dispatch({
          type: errorFieldActionTypes.TOGGLE_ERROR_FIELD,
          errorExists: !errorCheck,
          errorField: pricingErrorField
        });

        return errorCheck;

      case offersStep.availability:
        let availabilityErrorField = {
          minimum_units: false,
          maximum_units: false
        };

        if (!isEqualOrGreater(data.minimum_units?.value, data.maximum_units?.value)) {
          availabilityErrorField.maximum_units = true;
          availabilityErrorField.minimum_units = true;
          errorCheck = false;
        }
        if (getState().offers.availabilityErrorMsg) {
          if (checkErrorStatusForAllDays(getState().offers.availabilityErrorMsg)) {
            errorCheck = false;
          }
        }

        if (checkErrorValidationForAllDays(getState().offers.availabilityErrorIntervals)) {
          errorCheck = false;
        }

        dispatch({
          type: errorFieldActionTypes.TOGGLE_ERROR_FIELD,
          errorExists: !errorCheck,
          errorField: availabilityErrorField
        });

        return errorCheck;

      case offersStep.photos:
        return errorCheck;

      case offersStep.fulfilment:
        let fulfilmentErrorField = {
          booking_confirmation_copy_recipients: false,
          bookingRequestTo: false
        };

        if (
          !checkForEmptyField(data.booking_confirmation_copy_recipients) &&
          checkForValidEmail(data.booking_confirmation_copy_recipients)
        ) {
          fulfilmentErrorField.booking_confirmation_copy_recipients = true;
          errorCheck = false;
        }
        if (
          (!data.directly_bookable && checkForEmptyField(data.bookingRequestTo)) ||
          (!data.directly_bookable && checkForValidEmail(data.bookingRequestTo))
        ) {
          fulfilmentErrorField.bookingRequestTo = true;
          errorCheck = false;
        }
        dispatch({
          type: errorFieldActionTypes.TOGGLE_ERROR_FIELD,
          errorExists: !errorCheck,
          errorField: fulfilmentErrorField
        });
        return errorCheck;

      case offersStep.summary:
        return errorCheck;
      default:
        return true;
    }
  },
  resetErrorFieldAction: () => dispatch => {
    dispatch({
      type: errorFieldActionTypes.RESET_ERROR_FIELD
    });
  }
};
